export default __webpack_public_path__ + "static/media/vertical.e2b7f6f6.svg";